import React from "react";
import DefaultReportTemplate from "../defaultReportTemplate";
import dayjs from "dayjs";
import FormatDate from "../../masters/DateFormater";
import {Icon} from "../../../components/Component"
import { Tooltip } from "antd";
import { formatCurrency, formatCurrency2 } from "../../../utils/Utils";
import { useLocation, useNavigate, useParams } from "react-router";

function PaymentsAgingSummaryInvoiceReport() {
   const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const name = location.state?.name;
  const columns: any = [
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      width:200,
      render(text: any, record: any) {
        return (
          <span
            className="inlineTableCellLink"
            onClick={() => {
              navigate(`/invoice-preview-report/${record.invoiceNumber}`, {
                state: {
                  previousPath: `/payments-aging-summary-invoice-report/${id}`,
                  name,
                },
              });
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      width:150,
      render: (date: any) => <span>{date?FormatDate(date):"N/A"}</span>,
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      width:200
    },
    {
      title: "GRN Date",
      dataIndex: "grnDate",
      width:150,
      render: (date: any) => <span>{date?FormatDate(date):"N/A"}</span>,
    },
    {
      title: "Due Date",
      dataIndex: "paymentDueDate",
      width:150,
      render: (date: any) => <span>{date?FormatDate(date):"N/A"}</span>,
    },
    {
      title: "Aging",
      dataIndex: "aging",
      width:100,
      render:(aging:any)=><span>{aging} days</span>
    },
    {
      title: "Invoice Amount",
      dataIndex: "invoiceAmount",
       render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Outstanding Amount",
      dataIndex: "outstandingAmount",
       render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Overdue Amount",
      dataIndex: "overdueAmount",
       render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
  ];
  return (
    <DefaultReportTemplate
      pageTitle={`${name} - Payments Aging Summary Report`}
      moduleKey="paymentsAgingSummaryInvoiceReport"
      columns={columns}
      filtersOption={{
        site: false,
        contractor: false,
        dateRange: false,
        aging: false,
      }}
      previousPath="/payment-aging-summary-reports-list"
      extra={{
        tableScrollX: 1500,
        id
      }}
    />
  );
}


export default PaymentsAgingSummaryInvoiceReport